import React, { PropsWithChildren } from 'react';
import { BaseProps, RefOrUndefined } from './Types';

function constructMenu(
  { className, ...props }: PropsWithChildren<BaseProps<HTMLDivElement>>,
  ref: RefOrUndefined<HTMLDivElement>
) {
  return <div {...props} ref={ref} className={className} />;
}

export const Menu = React.forwardRef(constructMenu);
